/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as History } from '../../assets/themes/OPL/img/icons/History.svg';

function HistoryButton({ ...props }) {
    const { classes, callback, callbackParam, color, style, tooltipTitle, tooltipPlacement, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            tooltipTitle={tooltipTitle}
            style={style}
            tooltipPlacement={tooltipPlacement}
            classes={classes}
            icon={History}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

HistoryButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default HistoryButton;
